var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mini_program_body"},[_c('left-big-title',[_vm._v(_vm._s(_vm.$t('label.setup.mini.swap')))]),_c('dataTable',{attrs:{"viewType":_vm.slideShow}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }